import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Components
import AdvisorTransportationPanel from './AdvisorTransportationPanel';

// Selectors
import {
  getAdvisors,
  transportWithoutValet
} from 'store/reducers/apptOptions/selectors';
import {
  getAdvisorId,
  getTransportationOption
} from 'store/reducers/appointment/selectors';
import { getPolicyProperty } from 'store/reducers/dealerSettings/selectors';

// Actions
import {
  setAdvisor,
  setTransportationOption
} from 'store/reducers/appointment/actions';

const mapStateToProps = state => ({
  advisors: getAdvisors(state),
  transportations: transportWithoutValet(state),
  selectedAdvisorId: getAdvisorId(state),
  selectedTransportation: getTransportationOption(state),
  isGreeterPrefAllowed: getPolicyProperty(state)('greeterPrefAllowed')
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    { setAdvisor, setTransportationOption }
  )
)(AdvisorTransportationPanel);



// WEBPACK FOOTER //
// ./src/components/molecules/AdvisorTransportationPanel/AdvisorTransportationPanelContainer.js